import React, { useState, useEffect } from 'react';
import '../EvaluacionRiesgoModal.css';

const EvaluacionRiesgoModal4 = ({ anterior, onClose, formData, setFormData, finalizar }) => {
  const [vigilancia, setVigilancia] = useState(null);
  const [medios, setMedios] = useState(null);

  useEffect(() => {
    setVigilancia(formData.vigilancia ?? null);
    setMedios(formData.medios ?? null);
  }, [formData]);

  const vigilanciaOptions = [
    {
      text: `- El nivel Departamental tiene retrasos en la notificación o silencio epidemiológico.`,
      value: 15,
    },
    {
      text: `- El municipio o nivel local no tiene retraso en la notificación y realiza el análisis de los datos, cuenta con responsable de la vigilancia para el evento.`,
      value: 1,
    },
    {
      text: `- El municipio o nivel local tiene retrasos en la notificación, pero realiza el análisis de los datos y cuenta con responsable de la vigilancia para el evento.`,
      value: 5,
    },
    {
      text: `- El sistema de vigilancia no es capaz de identificar cambios inusuales o inusitados del comportamiento de los eventos de interés en salud pública.\n- Silencio epidemiológico persistente del nivel departamental.`,
      value: 50,
    },
  ];

  const mediosOptions = [
    {
      text: `- La situación no está en medios.`,
      value: 1,
    },
    {
      text: `- La situación aparece en medios locales, el nivel municipal tiene capacidad para la implementación del plan de manejo de medios y comunicación del riesgo.`,
      value: 5,
    },
    {
      text: `- La situación está en medios nacionales y el nivel departamental tiene plan de manejo de crisis.`,
      value: 15,
    },
    {
      text: `- La situación está en medios nacionales y el nivel departamental no tiene plan de manejo de medios o de crisis.`,
      value: 50,
    },
  ];

  const handleFinish = () => {
    // Solo permitir finalizar si ambas opciones están seleccionadas
    if (vigilancia == null || medios == null) {
      return; // o mostrar una alerta si quieres
    }

    const newFormData = {
      ...formData,
      vigilancia,
      medios
    };

    const {
      impactoSGSS = 0,
      impactoSocial = 0,
      extensionGeografica = 0,
      caracteristicasEvento = 0,
      vigilancia: vig = 0,
      medios: med = 0,
    } = newFormData;

    const puntajeTotal = impactoSGSS + impactoSocial + extensionGeografica + caracteristicasEvento + vig + med;

    let nivel = '';
    let respuesta = '';

    if (puntajeTotal < 25) {
      nivel = 'I';
      respuesta = 'Respuesta Municipal';
    } else if (puntajeTotal >= 25 && puntajeTotal <= 80) {
      nivel = 'II';
      respuesta = 'Respuesta Departamental';
    } else if (puntajeTotal > 80 && puntajeTotal <= 120) {
      nivel = 'III';
      respuesta = 'Respuesta Departamental/Nacional';
    } else if (puntajeTotal > 120) {
      nivel = 'IV';
      respuesta = 'Respuesta Nacional/Intersectorial/Internacional';
    }

    newFormData.evaluacionRiesgo = puntajeTotal;
    newFormData.nivelRiesgo = nivel;
    newFormData.respuesta = respuesta;

    setFormData(newFormData);

    if (typeof finalizar === 'function') {
      finalizar(newFormData);
    }
  };

  const handleBack = () => {
    setFormData({
      ...formData,
      vigilancia,
      medios
    });
    anterior();
  };

  // Variable que decide si el botón debe estar habilitado
  const isFinishEnabled = vigilancia != null && medios != null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3 className="text-center mb-3">EVALUACIÓN DEL RIESGO</h3>
        <div className="row">
          <div className="col-md-6">
            <h6>Vigilancia epidemiológica</h6>
            <div className="cuadros-container">
              {vigilanciaOptions.map((item, index) => (
                <div
                  key={index}
                  className={`opcion-cuadro ${vigilancia === item.value ? 'seleccionado' : ''}`}
                  onClick={() => setVigilancia(item.value)}
                >
                  <input
                    type="radio"
                    name="vigilancia"
                    checked={vigilancia === item.value}
                    readOnly
                    className="mb-2"
                  />
                  <pre className="opcion-texto">{item.text}</pre>
                </div>
              ))}
            </div>
          </div>

          <div className="col-md-6">
            <h6>Medios de comunicación</h6>
            <div className="cuadros-container">
              {mediosOptions.map((item, index) => (
                <div
                  key={index}
                  className={`opcion-cuadro ${medios === item.value ? 'seleccionado' : ''}`}
                  onClick={() => setMedios(item.value)}
                >
                  <input
                    type="radio"
                    name="medios"
                    checked={medios === item.value}
                    readOnly
                    className="mb-2"
                  />
                  <pre className="opcion-texto">{item.text}</pre>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="text-center mt-4">
          <button className="btn btn-outline-primary me-2" onClick={handleBack}>
            Anterior
          </button>
          <button
            className="btn btn-success"
            onClick={handleFinish}
            disabled={!isFinishEnabled}
          >
            Finalizar Evaluación
          </button>
        </div>
      </div>
    </div>
  );
};

export default EvaluacionRiesgoModal4;
